module.exports = __webpack_public_path__ + "static/bottom-41cc1301631f5e6a63542c906f61a4db.png";